/** Uzi. Open bolt, 9 mm, a 32-round stick in the grip. Slower than the MP5 and wobblier. */

import type { WeaponSpec } from '@/sim/weapons/weaponContract';

export const UZI = {
  id: 'uzi',
  label: 'Uzi',
  classId: 'smg',
  caliber: '9x19 mm',
  fireMode: 'auto',
  roundsPerMinute: 600,
  magSize: 32,
  reserveAmmo: 192,
  reloadSeconds: 2.2,
  emptyReloadSeconds: 2.8,
  reloadStyle: 'magazine',
  damage: 24,
  damageTypeId: 'ballistic',
  falloff: { fullMetres: 18, zeroMetres: 90, minScale: 0.3 },
  pellets: 1,
  adsSpreadMoa: 11,
  hipSpreadMoa: 150,
  bloomMoaPerShot: 10,
  bloomMoaCap: 95,
  bloomDecayMoaPerSecond: 110,
  moveSpreadMoaPerMps: 17,
  crouchSpreadScale: 0.7,
  airborneSpreadMoa: 75,
  recoilPattern: [
    { pitch: 0.75, yaw: -0.1 },
    { pitch: 0.7, yaw: 0.22 },
    { pitch: 0.68, yaw: -0.28 },
    { pitch: 0.65, yaw: 0.3 },
    { pitch: 0.62, yaw: -0.2 },
    { pitch: 0.6, yaw: 0.12 },
    { pitch: 0.58, yaw: -0.34 },
    { pitch: 0.56, yaw: 0.26 },
  ],
  recoilResetSeconds: 0.28,
  recoilRecoveryPerSecond: 6.5,
  adsFovDegrees: 60,
  adsSeconds: 0.16,
  adsSensitivityScale: 0.8,
  muzzleVelocity: 390,
} as const satisfies WeaponSpec;
